import { useEffect, useState } from 'react'
import { useLoaderData } from 'react-router-dom'
import type { TransferData } from 'types/commons/model'
import { TransferPageSchema } from 'types/commons/model'
import { ZOD_ERROR } from 'utils/constants'
import { useGoToShipmentPreparation } from './preparation/Preparation.navigator'

export const useShipment = () => {
  const preparationPage = useGoToShipmentPreparation()
  const rawOrders = useLoaderData()
  const [transfers, setTransfers] = useState<TransferData[]>([])

  useEffect(() => {
    const result = TransferPageSchema.safeParse(rawOrders)
    if (!result.success) {
      console.error(result.error)
      throw Error(ZOD_ERROR)
    }

    setTransfers(result.data.data)
  }, [rawOrders])

  const goToPreparation = (transferId: string, docNum: string) => {
    preparationPage.go(transferId, docNum)
  }

  return { transfers, actions: { goToPreparation } }
}
